import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Button } from "components/ui/button";
import { ModalDetailsBc } from "./modal-bc";
import { ModalDetailsException } from "./modal-exception";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface ModalRequestProps {
  requestData: any;
}

const detailComponents: Record<string, React.FC<{ requestData: any }>> = {
  BC: ModalDetailsBc,
  EXCEPTION: ModalDetailsException,
};
export function ModalRequest({ requestData }: ModalRequestProps) {
  const { handleModal } = useDialogModal();

  const DetailComponent =
    detailComponents[requestData.type_solicitation] ||
    (() => <p>Tipo não suportado</p>);

  return (
    <div className="flex flex-col">
      <div className="px-6 pt-6">
        <DetailComponent requestData={requestData} />
      </div>

      <div className="flex justify-end p-4 pt-6 border-t bg-white mt-6">
        <Button onClick={() => handleModal({ isOpen: false })}>Fechar</Button>
      </div>
    </div>
  );
}
